import { useNavigate } from 'react-router-dom';
import { SignOutUser, auth, userStateListener } from 'firebaseUtil';
import { createContext, useState, useEffect } from 'react';
import http from 'utils/axiosService';
import { domain } from 'config';
import { setErrorType } from 'store/reducers/error';
import { useDispatch } from 'react-redux';

import { setUser } from 'store/reducers/user';
import { getRedirectResult } from 'firebase/auth';
const endpoint = `${domain}/api/user`;
export const AuthContext = createContext({
  currentUser: {},
  setCurrentUser: (_user) => {},
  signOut: () => {}
});

// Local-dev-only escape hatch: set REACT_APP_BYPASS_AUTH=true (e.g. in a gitignored .env.development.local)
// to skip the Google/Microsoft login popup and act as an already-authenticated dev user. The backend must
// also have its matching BypassAuth flag enabled, otherwise API calls will still get a real 401.
const BYPASS_AUTH = process.env.REACT_APP_BYPASS_AUTH === 'true';
const DEV_USER = { email: 'ye.david@gmail.com', displayName: 'Dev Test User' };

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState({ isLoading: true, data: {} });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (BYPASS_AUTH) {
      setCurrentUser({ isLoading: false, data: DEV_USER });
      http.get(`${domain}/api/public/GetUserRole`, { params: { email: DEV_USER.email } }).then((role) => {
        if (role.data) {
          dispatch(setUser({ user: { role: role.data.split(',') } }));
        }
      });
      return;
    }

    getRedirectResult(auth)
      .then((result) => {
        setCurrentUser({ isLoading: false, data: result?.user });
      })
      .catch((error) => {
        console.error('getRedirectResult Error', error);
      });

    const unsubscribe = userStateListener(async (user) => {
      console.log('userStateListener', user);
      if (user && !currentUser?.data?.isAuthenticated) {
        const isUserAuthorized = await checkUser(user);
        if (isUserAuthorized) {
          setCurrentUser({ isLoading: false, data: user });
          dispatch(setErrorType({ errorType: { message: '', severity: 'error' } }));
        } else {
          dispatch(setErrorType({ errorType: { message: 'Account Not Authorized For Access', severity: 'error' } }));
          signOut();
        }

        const role = await http.get(`${domain}/api/public/GetUserRole`, { params: { email: user.email } });
        if (role.data) {
          dispatch(setUser({ user: { role: role.data.split(',') } }));
        }
      }
    });
    return unsubscribe;
  }, []);

  const checkUser = async (user) => {
    return await http
      .get(endpoint)
      .then((response) => {
        return true;
      })
      .catch((response) => {
        return false;
      });
  };
  // As soon as setting the current user to null,
  // the user will be redirected to the home page.
  const signOut = () => {
    SignOutUser();
    setCurrentUser({ isLoading: false, data: null });
    navigate('/');
  };

  const value = {
    currentUser,
    setCurrentUser,
    signOut
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
